import Footer from "../components/Footer";
import RegisterHeader from "./components/RegisterHeader";
import RegisterBody from "./components/RegisterBody";
import SectionHeader from "../components/SectionHeader";
import React, { useState } from "react";
import { useRouter } from "next/router";
import { registerUseCase } from "../lib/dependencies";

export default function Register() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [age, setAge] = useState(0);

  const [accountCreated, setAccountCreated] = useState(false);

  const [gender, setGender] = useState(0);
  const router = useRouter();

  async function register() {
    const response = await registerUseCase.createAccount(
      username,
      password,
      confirmPassword,
      email,
      firstName,
      lastName,
      age,
      gender
    );
    setAccountCreated(!accountCreated);
    if (response.error) {
      setAccountCreated(false);
      return window.alert(JSON.stringify(response));
    }
  }

  function handleUserName(event) {
    setUsername(event.target.value);
  }
  function handlePassword(event) {
    setPassword(event.target.value);
  }
  function handleConfirmPassword(event) {
    setConfirmPassword(event.target.value);
  }
  function handleFirstName(event) {
    setFirstName(event.target.value);
  }
  function handleEmail(event) {
    setEmail(event.target.value);
  }
  function handleLastName(event) {
    setLastName(event.target.value);
  }
  function handleAge(event) {
    setAge(event.target.value);
  }
  function handleGender(genderNumber) {
    setGender(genderNumber);
  }
  return (
    <div>
      <RegisterHeader />
      <SectionHeader>REGISTERATION</SectionHeader>
      <RegisterBody
        handleUserName={handleUserName}
        handlePassword={handlePassword}
        handleConfirmPassword={handleConfirmPassword}
        handleFirstName={handleFirstName}
        handleLastName={handleLastName}
        handleAge={handleAge}
        handleGender={handleGender}
        handleEmail={handleEmail}
        register={register}
        accountCreated={accountCreated}
        email={email}
        username={username}
      />
      <Footer />
    </div>
  );
}
